class CacheItem {
    get isExpired() {
        return Date.now() - this.saveTime > this.ttl;
    }
}
class TtlCache {
    constructor(ttl) {
        this.cache = new Map();
        this.globalTtl = ttl;
    }
    set(key, value, ttl) {
        const item = new CacheItem();
        item.key = key;
        item.value = value;
        item.saveTime = Date.now();
        item.ttl = ttl !== null && ttl !== void 0 ? ttl : this.globalTtl;
        this.cache.set(key, item);
    }
    get(key) {
        const item = this.cache.get(key);
        if (!item) {
            return undefined;
        }
        if (item.isExpired) {
            this.delete(key);
            return undefined;
        }
        return item.value;
    }
    delete(key) {
        this.cache.delete(key);
    }
    has(key) {
        if (this.get(key) !== undefined) {
            return true;
        }
        return false;
    }
    prune() {
        this.cache.forEach(item => {
            if (item.isExpired) {
                this.delete(item.key);
            }
        });
    }
}

export { TtlCache };
//# sourceMappingURL=ttlCache.js.map
